import React from 'react';
import { useNavigate } from 'react-router-dom';
const Privacy = () => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="legal-page">
      <button className="back-button" onClick={handleBack}>
        ← Back
      </button>
      <h1>Privacy Policy</h1>
      <p><strong>Last updated:</strong> {new Date().toLocaleDateString()}</p>
      
      <h2>1. Introduction</h2>
      <p>
        MTSolar ("we," "our," or "us") operates the web portal located at https://projects.mtsolar.us 
        (the "Service"). This Privacy Policy explains how we collect, use, disclose, and safeguard your 
        information when you use our Service for designing and ordering solar products.
      </p>

      <h2>2. Information We Collect</h2>
      
      <h3>2.1 Personal Information</h3>
      <p>We collect information you provide directly to us, including:</p>
      <ul>
        <li><strong>Contact Information:</strong> Name, email address, phone number, and mailing address</li>
        <li><strong>Account Information:</strong> Username, password, and account preferences</li>
        <li><strong>Project Information:</strong> Solar system specifications, design requirements, and project details</li>
        <li><strong>Order Information:</strong> Quote requests, purchase orders, and payment information</li>
        <li><strong>Communications:</strong> Messages, support requests, and feedback you send to us</li>
      </ul>

      <h3>2.2 Automatically Collected Information</h3>
      <p>When you use our Service, we automatically collect certain information, including:</p>
      <ul>
        <li><strong>Usage Data:</strong> Information about how you interact with our Service</li>
        <li><strong>Device Information:</strong> IP address, browser type, operating system, and device identifiers</li>
        <li><strong>Log Data:</strong> Server logs, including access times, pages viewed, and referring URLs</li>
        <li><strong>Cookies and Tracking:</strong> Information collected through cookies and similar technologies</li>
      </ul>

      <h2>3. How We Use Your Information</h2>
      <p>We use the information we collect solely for the purpose of providing our solar product design and ordering services:</p>
      <ul>
        <li><strong>Service Provision:</strong> To create and manage your account, process orders, and provide customer support</li>
        <li><strong>Project Management:</strong> To design solar systems, generate quotes, and track project progress</li>
        <li><strong>Communication:</strong> To respond to your inquiries, send order updates, and provide service notifications</li>
        <li><strong>Service Improvement:</strong> To analyze usage patterns and improve our platform functionality</li>
        <li><strong>Legal Compliance:</strong> To comply with applicable laws, regulations, and legal processes</li>
      </ul>

      <h2>4. Information Sharing and Disclosure</h2>
      <p>We do not sell, rent, or share your personal information with third parties except in the following limited circumstances:</p>
      
      <h3>4.1 Service Providers</h3>
      <p>We may share information with trusted third-party service providers who assist us in:</p>
      <ul>
        <li>Processing payments and financial transactions</li>
        <li>Providing customer support services</li>
        <li>Hosting and maintaining our Service</li>
        <li>Analyzing usage data and improving our Service</li>
      </ul>

      <h3>4.2 Business Transfers</h3>
      <p>In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of the transaction.</p>

      <h3>4.3 Legal Requirements</h3>
      <p>We may disclose your information if required to do so by law or in response to valid legal requests.</p>

      <h3>4.4 Consent</h3>
      <p>We may share your information with your explicit consent for specific purposes.</p>

      <h2>5. Data Security</h2>
      <p>
        We implement appropriate technical and organizational security measures to protect your personal information 
        against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over 
        the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
      </p>

      <h2>6. Data Retention</h2>
      <p>
        We retain your personal information for as long as necessary to provide our services, comply with legal 
        obligations, resolve disputes, and enforce our agreements. Project and order information may be retained 
        for longer periods to maintain service history and comply with business requirements.
      </p>

      <h2>7. Your Rights and Choices</h2>
      <p>Depending on your location, you may have certain rights regarding your personal information:</p>
      <ul>
        <li><strong>Access:</strong> Request access to the personal information we hold about you</li>
        <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
        <li><strong>Deletion:</strong> Request deletion of your personal information</li>
        <li><strong>Portability:</strong> Request a copy of your data in a portable format</li>
        <li><strong>Objection:</strong> Object to certain processing of your personal information</li>
      </ul>
      <p>To exercise these rights, please contact us using the information provided in the Contact section.</p>

      <h2>8. Cookies and Tracking Technologies</h2>
      <p>
        We use cookies and similar tracking technologies to enhance your experience on our Service. Cookies are 
        small data files stored on your device that help us remember your preferences and improve our Service. 
        You can control cookie settings through your browser preferences, but disabling cookies may affect 
        Service functionality.
      </p>

      <h2>9. Third-Party Links</h2>
      <p>
        Our Service may contain links to third-party websites or services. We are not responsible for the privacy 
        practices or content of these third parties. We encourage you to review the privacy policies of any 
        third-party sites you visit.
      </p>

      <h2>10. Children's Privacy</h2>
      <p>
        Our Service is not intended for children under 13 years of age. We do not knowingly collect personal 
        information from children under 13. If we become aware that we have collected personal information 
        from a child under 13, we will take steps to delete such information.
      </p>

      <h2>11. International Data Transfers</h2>
      <p>
        Your information may be transferred to and processed in countries other than your own. We ensure that 
        such transfers comply with applicable data protection laws and implement appropriate safeguards to 
        protect your information.
      </p>

      <h2>12. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. We will notify you of any material changes by 
        posting the new Privacy Policy on this page and updating the "Last updated" date. We encourage you 
        to review this Privacy Policy periodically for any changes.
      </p>

      <h2>13. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy or our privacy practices, please contact us:
      </p>
      <ul>
        <li>Through the contact information provided on our website</li>
        <li>Via the support channels available in our Service</li>
      </ul>

      <p className="legal-page__updated">
        This Privacy Policy is effective as of the date listed above and will remain in effect except with 
        respect to any changes in its provisions in the future, which will be in effect immediately after 
        being posted on this page.
      </p>
    </div>
  );
};

export default Privacy;
